const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://n0jkbaykal.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_API_URL: 'https://eyx6520x30.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.3',
    HOSTNAME: 'https://company.testing.platform.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.testing.platform.forwoodsafety.com',
    WEBSOCKET: 'wss://0bmk6ppdq1.execute-api.us-west-2.amazonaws.com/testing'
  },
};

export default config;